import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchMeta = () => api.get("/meta").then((r) => r.data);
export const fetchEvents = (params) =>
    api.get("/events", { params }).then((r) => r.data);
export const fetchCountySummary = (params) =>
    api.get("/events/county-summary", { params }).then((r) => r.data);
export const createEvent = (payload) =>
    api.post("/events", payload).then((r) => r.data);
export const updateEvent = (id, payload) =>
    api.put(`/events/${id}`, payload).then((r) => r.data);
export const deleteEvent = (id) =>
    api.delete(`/events/${id}`).then((r) => r.data);

// Public submissions (FREE — no payment)
export const submitFreeEvent = (payload) =>
    api.post("/submissions/free", payload).then((r) => r.data);

// Public submissions (paid via Stripe — kept for backwards compatibility)
export const createSubmissionCheckout = (payload) =>
    api.post("/submissions/checkout", payload).then((r) => r.data);
export const fetchSubmissionStatus = (sessionId) =>
    api.get(`/submissions/status/${sessionId}`).then((r) => r.data);

// Public image upload (for event submissions)
export const uploadImage = (file) => {
    const form = new FormData();
    form.append("file", file);
    return api
        .post("/uploads/image", form, {
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data);
};

// Admin sees ALL events (paid + pending_payment)
export const fetchAllEvents = () =>
    api.get("/admin/events").then((r) => r.data);

// Auth
export const loginRequest = (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
